import { useScriptTag } from '@vueuse/core'
export const useRecaptcha = () => {
  const config = useRuntimeConfig()
  return new Promise((resolve, reject) => {
    // @ts-ignore  grecaptcha is not defined in the standard 'Window' type and is only available after the script is loaded
    if (typeof window.grecaptcha !== 'undefined') { return resolve('Recaptcha already loaded') }
    useScriptTag(`https://www.google.com/recaptcha/enterprise.js?render=${config.public.recaptchaKey}`, () => resolve('Recaptcha loaded'))
  })
}
